import { render, staticRenderFns } from "./AddLanguageDialog.vue?vue&type=template&id=7cd38a8b&"
import script from "./AddLanguageDialog.vue?vue&type=script&lang=js&"
export * from "./AddLanguageDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports